import React from 'react';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="bg-brand-light px-4 py-6 sm:px-6" aria-labelledby="pain-heading" data-id="element-114" data-mp="38xoher0tacsw">
      <h2 id="pain-heading" className="mb-2 text-center text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-115" data-mp="2uy5mx10xazz2">
        DOES THIS SOUND FAMILIAR?
      </h2>
      <p className="mb-1 text-center text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-116" data-mp="2z1twtqd127nh">
        You love helping athletes improve their boxing skills and perform at their best... But
        planning every session is becoming another full-time job.
      </p>
      <p className="mb-3 text-center font-heading text-xs font-semibold leading-snug text-brand-ink sm:text-sm" data-id="element-117" data-mp="2bb7odxz42lcy">
        If you're a Boxing Coach working in a gym, boxing club, academy, or with private athletes...
        You've probably experienced at least one of these situations.
      </p>
      <div className="space-y-2" data-id="element-118" data-mp="278ujtcw3othr">
        {pains.map(pain => <article key={pain.title} className="flex gap-2.5 rounded-xl border-l-4 border-brand-red bg-white p-3 shadow-sm" data-id="element-119" data-mp="3rn0svhkbgo5l">
            <span className="text-xl leading-none" aria-hidden="true" data-id="element-120" data-mp="3nkw0em5ltxkj">
              {pain.emoji}
            </span>
            <div data-id="element-121" data-mp="5dq3qcyu7kda">
              <h3 className="mb-1 text-base leading-none text-brand-ink sm:text-lg" data-id="element-122" data-mp="gpy235wgjmp">
                {pain.title}
              </h3>
              <p className="text-[11px] leading-snug text-brand-muted sm:text-xs" data-id="element-123" data-mp="38vrgn0j5vlab">
                {pain.lines.join(' ')}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}